import React, { CSSProperties } from "react";

export default function IconWifiAlt(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 20}
			height={props.size ?? 20}
			viewBox="0 0 20 20"
		>
			<mask
				id="mask0_140_5"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="20"
				height="20"
			>
				<rect width="20" height="20" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_140_5)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.34319 3.2929C4.73371 3.68342 4.73371 4.31659 4.34318 4.70711C3.6003 5.44998 3.01102 6.3319 2.60897 7.30251C2.20693 8.27312 2 9.31342 2 10.364C2 11.4146 2.20693 12.4549 2.60897 13.4255C3.01102 14.3961 3.6003 15.278 4.34318 16.0209C4.73371 16.4114 4.73371 17.0446 4.34319 17.4351C3.95267 17.8256 3.3195 17.8256 2.92898 17.4351C2.00038 16.5065 1.26377 15.4041 0.761216 14.1909C0.258662 12.9776 0 11.6772 0 10.364C0 9.05077 0.258662 7.7504 0.761216 6.53714C1.26377 5.32387 2.00038 4.22148 2.92898 3.29289C3.3195 2.90237 3.95267 2.90237 4.34319 3.2929ZM15.657 3.2929C16.0475 2.90237 16.6807 2.90237 17.0712 3.29289C17.9998 4.22148 18.7364 5.32387 19.2389 6.53714C19.7415 7.7504 20.0002 9.05077 20.0002 10.364C20.0002 11.6772 19.7415 12.9776 19.2389 14.1909C18.7364 15.4041 17.9998 16.5065 17.0712 17.4351C16.6807 17.8256 16.0475 17.8256 15.657 17.4351C15.2664 17.0446 15.2664 16.4114 15.657 16.0209C16.3999 15.278 16.9891 14.3961 17.3912 13.4255C17.7932 12.4549 18.0002 11.4146 18.0002 10.364C18.0002 9.31342 17.7932 8.27312 17.3912 7.30251C16.9891 6.3319 16.3999 5.44998 15.657 4.70711C15.2664 4.31659 15.2664 3.68342 15.657 3.2929ZM7.17108 6.12179C7.56166 6.51225 7.56176 7.14542 7.17129 7.536C6.42141 8.28611 6.00015 9.30334 6.00015 10.364C6.00015 11.4247 6.42141 12.4419 7.17129 13.192C7.56176 13.5826 7.56166 14.2157 7.17108 14.6062C6.78049 14.9967 6.14733 14.9966 5.75686 14.606C4.63204 13.4808 4.00015 11.955 4.00015 10.364C4.00015 8.77302 4.63204 7.24717 5.75686 6.122C6.14733 5.73142 6.78049 5.73132 7.17108 6.12179ZM12.8291 6.12179C13.2197 5.73132 13.8528 5.73142 14.2433 6.122C15.3681 7.24717 16 8.77302 16 10.364C16 11.955 15.3681 13.4808 14.2433 14.606C13.8528 14.9966 13.2197 14.9967 12.8291 14.6062C12.4385 14.2157 12.4384 13.5826 12.8289 13.192C13.5787 12.4419 14 11.4247 14 10.364C14 9.30334 13.5787 8.28611 12.8289 7.536C12.4384 7.14542 12.4385 6.51225 12.8291 6.12179ZM8.58587 8.94979C8.96094 8.57471 9.46964 8.364 10.0001 8.364C10.5305 8.364 11.0392 8.57471 11.4143 8.94979C11.7894 9.32486 12.0001 9.83357 12.0001 10.364C12.0001 10.8944 11.7894 11.4031 11.4143 11.7782C11.0392 12.1533 10.5305 12.364 10.0001 12.364C9.46964 12.364 8.96094 12.1533 8.58587 11.7782C8.21079 11.4031 8.00008 10.8944 8.00008 10.364C8.00008 9.83357 8.21079 9.32486 8.58587 8.94979Z"
					fill={props.color ?? "#00255D"}
				/>
			</g>
		</svg>
	);
}
